import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'AVP' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'AVP', label: 'Average Price', pane: 'sub', params: [], outputs: ['avp'], tailSafe: false })
